/**
 * ⭐ THE CATALOG'S OFF STUB (T1749 M5) — the `feedback/host-off.tsx` shape, for
 * the same reason and with the same guarantee.
 *
 * ⛔ THE WHOLE SCREEN IS SWAPPED, NOT JUST ITS BODY. `scripts/build-client.mjs`
 * resolves `./screens/Catalog.js` to THIS file unless `ECMB_CATALOG` is `1`, so
 * `Catalog.tsx`, `catalog.css` and every specimen they reach are never in the
 * module graph — absence is STRUCTURAL, not a dead-code-elimination hope. A stub
 * that merely returned null from inside `Catalog.tsx` would still ship the
 * specimens, the stylesheet and the cell-class marker in `client.css`, which is
 * what `scripts/check-catalog.mjs` greps the built artefacts for.
 *
 * ⚠️ IT RENDERS NOTHING RATHER THAN A MESSAGE. The catalog's entry is a quiet link
 * on the price-book shelf, and in the default posture a reader who reaches this
 * screen has navigated somewhere that does not exist in this build; a sentence
 * explaining a build flag is developer copy on an operator's screen. The link is
 * unconditional on purpose — `check-catalog.mjs`'s OFF leg reds if either marker
 * string reaches the bundle, so the link's own wording must not be the heading.
 *
 * ⛔ AND NEITHER MAY THIS COMMENT. THIS MODULE SHIPS IN THE OFF POSTURE, and
 * `client.js.map` embeds its source verbatim, so writing either marker string in
 * prose here puts it in a graded artefact and reds the OFF leg — measured on this
 * file's first draft, which quoted both. Name the markers indirectly ("the
 * heading", "the cell class"); the same applies to `App.tsx` and `Admin.tsx`.
 * ⚠️ That the gate CAUGHT a comment is the gate working, not a false positive: it
 * grades what the artefact contains, and prose in a shipped module is content.
 */
import type { VNode } from 'preact';

/**
 * ⛔ THE HALF THAT CLOSES THE BLANK PANE, and it is the reason this stub is more
 * than `() => null`. `Catalog.tsx` exports this name as `true`; here it is
 * `false`, and `App.tsx` reads it to decide whether Admin's shelf gets an opener
 * at all. So in the shipped posture Helen's shelf carries NO `Design components`
 * control — the link and the screen are one fact, decided once, by which module
 * the build resolved.
 * ⚠️ THE `case 'catalog'` ARM AND THE ScreenId STAY IN BOTH POSTURES, deliberately:
 * the switch has no `default:`, so a ScreenId without an arm is a COMPILE error
 * rather than a blank pane, and keeping the arm is what makes both postures
 * typecheck from one source. Nothing can reach that arm when nothing navigates to
 * it — `catalog-off.spec` coverage is the Admin arm in `catalog.spec.tsx`.
 */
export const CATALOG_PRESENT = false;

export function Catalog(): VNode | null {
  return null;
}
